import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import videoFile from './13-eva.webm';

export const slide = () => {
  return (
    <Slide notes="EVA video demonstration" transition="fade" visualizer="full">
      <WebContent>
        <div className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none object-cover opacity-60"
            src={videoFile}
          />
        </div>
      </WebContent>
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
    </Slide>
  );
};
